<template>
    <div v-bind:class="[ 'select-col', 'component-' + box.component]">
        <div v-bind:class="[ 'mobile-fabric-preview', (currentData.ref_number !== 'none') ? 'show-border' : '']">
            <button v-if="currentData.ref_number !== 'none'" type="button" class="zoom-btn"
                    v-bind:data-refnr="currentData.ref_number"
                    v-bind:data-title="currentData.name" v-bind:data-infotext='currentData.infotext'
                    v-bind:data-price='currentData.price' v-bind:data-weave="currentData.weave"
                    v-bind:data-yarn="currentData.yarn"
                    v-bind:data-weight="currentData.weight" v-bind:data-composition="currentData.composition" v-bind:data-zoom="currentData.zoom"
                    @click="zoomFabric" title="{{ translations['Further informations'] }}">Details
            </button>
        </div>
        <div class="top-step-name basic-border basic-color">{{ box.title }}<span v-if="box.extra" class="extra_price"
                                                                                 v-bind:style="[((isactive !== 'none' && isactive !== personal['fabric']) ? {visibility: 'visible'} : {visibility: 'hidden'})]"> + {{ box.extra }} €</span>
        </div>
        <div class="designer-detailbox-description">
            <p><span id="detail-description">{{{ box.todo }}}</span></p>
        </div>
        <!-- FILTERBOXES -->
        <filter :filtercolor="filtercolor" :filterpattern="filterpattern" :filterweave="filterweave"
                :filtermaterial="filtermaterial"
                :filteroccasion="filteroccasion" :range1="range1" :range2="range2" :boolfilter="boolfilter"
                :filtername="filtername"></filter>
        <!-- SELECTBOXES FOR DESIGNER -->
        <fabrics :baseurl="baseurl" :box="box" :fabrics="fabrics" :filtercolor="filtercolor"
                 :filterpattern="filterpattern" :filterweave="filterweave" :filtermaterial="filtermaterial"
                 :filteroccasion="filteroccasion" :range1="range1"
                 :range2="range2" :boolfilter="boolfilter" :fields="fields" :personal="personal"
                 :filtername="filtername" :muster1="muster1" :muster2="muster2"
                 :muster3="muster3" :muster4="muster4"></fabrics>

        <div v-if="['contrast_bs_bottom_outside'].indexOf(box.component) > -1" class="preview">
            <img v-bind:src="this.baseurl + 'media/jack/shirt/detail/contrast_bs_bottom_outside.jpg'" width="323"
                 height="216"/>
        </div>
        <div v-if="['contrast_bs_upper_inside'].indexOf(box.component) > -1" class="preview">
            <img v-bind:src="this.baseurl + 'media/jack/shirt/detail/contrast_bs_upper_inside.jpg'" width="323"
                 height="216"/>
        </div>
        <div v-if="['contrast_sleeve_buttons_outside'].indexOf(box.component) > -1" class="preview">
            <img v-bind:src="this.baseurl + 'media/jack/shirt/detail/contrast_sleeve_buttons_outside.jpg'" width="323"
                 height="216"/>
        </div>
        <div v-if="['contrast_sleeve_buttons_inside'].indexOf(box.component) > -1" class="preview">
            <img v-bind:src="this.baseurl + 'media/jack/shirt/detail/contrast_sleeve_buttons_inside.jpg'" width="323"
                 height="216"/>
        </div>
        <div v-if="['contrast_collar_bottom'].indexOf(box.component) > -1" class="preview">
            <img v-bind:src="this.baseurl + 'media/jack/shirt/detail/contrast_collar_bottom.jpg'" width="323"
                 height="323"/>
        </div>
        <div v-if="['contrast_collar_stand_outer'].indexOf(box.component) > -1" class="preview">
            <img v-bind:src="this.baseurl + 'media/jack/shirt/detail/contrast_collar_stand_outer.jpg'" width="323"
                 height="323"/>
        </div>
        <div v-if="['contrast_collar_stand_inner'].indexOf(box.component) > -1" class="preview">
            <img v-bind:src="this.baseurl + 'media/jack/shirt/detail/contrast_collar_stand_inner.jpg'" width="323"
                 height="323"/>
        </div>
    </div>
    <zoom v-if="zoom" :zoom="zoom" :show.sync="show" :globals="globals" :muster1="muster1" :muster2="muster2"
          :muster3="muster3" :muster4="muster4"></zoom>
</template>

<script>
var jQuery = require('jquery')

import Filter from '../partials/Filter.vue'
import Fabrics from '../partials/Fabrics.vue'
import Zoom from '../partials/Zoom.vue'

export default {
  name: 'ConstrastCollarOutside',
  data: function () {
    return {
      showPattern: false,
      showColor: false,
      showWeave: false,
      showMaterial: false,
      showOccasion: false,
      showPrice: false,
      showSeason: false,
      selectPrice: '74.90',
      filtercolor: '',
      filterpattern: '',
      filterweave: '',
      filtermaterial: '',
      filteroccasion: '',
      filtername: '',
      isactive: this.isactive,
      globals: window.shirtdesigner,
      translations: window.shirtdesigner.translations,
      fields: [ 'name', 'color', 'weave', 'season', 'occasion', 'pattern' ],
      boolfilter: { 'topseller': '0', 'new': '0' },
      range1: { value: 49, min: 49, max: 100 },
      range2: { value: 100, min: 50, max: 100 },
      currentData: {},
      scrolling: false
    }
  },
  components: {
    Filter,
    Fabrics,
    Zoom
  },
  props: {
    'box': Object,
    'baseurl': String,
    'personal': Object,
    'isactive': String,
    'fabrics': Array,
    'filtercolor': String,
    'filterpattern': String,
    'filterweave': String,
    'filtermaterial': String,
    'filteroccasion': String,
    'filtername': String,
    'muster1': String,
    'muster2': String,
    'muster3': String,
    'muster4': String,
    'zoom': Object,
    show: {
      type: Boolean,
      required: true,
      twoWay: true
    }
  },
  events: {
    setFilter: function (event, callback) {
      switch (event.currentTarget.dataset.select) {
        case 'color':
          if (event.currentTarget.id === 'all') {
            this.filtercolor = ''
            this.showColor = false
            callback('Color')
          } else {
            this.filtercolor = event.currentTarget.id
            callback(this.filtercolor)
          }
          break
        case 'pattern':
          if (event.currentTarget.id === 'all') {
            this.filterpattern = ''
            this.showPattern = false
            callback('Pattern')
          } else {
            this.filterpattern = event.currentTarget.id
            callback(this.filterpattern)
          }
          break
        case 'weave':
          if (event.currentTarget.id === 'all') {
            this.filterweave = ''
            this.showWeave = false
            callback('Weave')
          } else {
            this.filterweave = event.currentTarget.id
            callback(this.filterweave)
          }
          break
        case 'material':
          if (event.currentTarget.id === 'all') {
            this.filtermaterial = ''
            this.showMaterial = false
            callback('Material')
          } else {
            this.filtermaterial = event.currentTarget.id
            callback(this.filtermaterial)
          }
          break
        case 'occasion':
          if (event.currentTarget.id === 'all') {
            this.filteroccasion = ''
            this.showOccasion = false
            callback('Occasion')
          } else {
            this.filteroccasion = event.currentTarget.id
            callback(this.filteroccasion)
          }
          break
        case 'name':
          this.filtername = event.currentTarget.value
          callback(this.filtername)
          break
      }
    },
    setBoolFilter: function (event, callback) {
      if (this.boolfilter[event.currentTarget.id] !== '1') {
        this.boolfilter[event.currentTarget.id] = '1'
        callback('1')
      } else {
        this.boolfilter[event.currentTarget.id] = '0'
        callback('0')
      }
    },
    resetFilter: function () {
      this.showPattern = false
      this.showColor = false
      this.showWeave = false
      this.showMaterial = false
      this.showOccasion = false
      this.showSeason = false
      this.showPrice = false
      this.showName = false
      this.range1.value = this.range1.min
      this.range2.value = this.range2.max
      this.resetBoolFilter()
      this.filtercolor = ''
      this.filterpattern = ''
      this.filterweave = ''
      this.filtermaterial = ''
      this.filteroccasion = ''
      this.filtername = ''
    },
    updatePersonal: function (event) {
      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id])
      this.setCurrentData(event.currentTarget.id)
      this.isactive = event.currentTarget.id
    },
    checkDesign: function (event) {
      this.$dispatch('mainCheckDesign', event, function () {})
    }
  },
  methods: {
    selectFabric: function (event) {
      this.$dispatch('getFabricData', event)
    },
    thumbUrl: function (event) {
      return this.baseurl + event.currentTarget.dataset.thumb
    },
    resetBoolFilter: function () {
      var b
      for (b in this.boolfilter) {
        this.boolfilter[b] = '0'
      }
    },
    setCurrentData: function (sku) {
      if (sku !== 'none') {
        this.currentData = jQuery.grep(this.fabrics, function (e) { return e.ref_number === sku })[0]
      } else {
        var object = {}
        object['ref_number'] = 'none'
        this.currentData = object
      }
    },
    zoomFabric: function (event) {
      this.zoom = {
        img: this.baseurl + 'media/' + event.currentTarget.dataset.zoom,
        title: event.currentTarget.dataset.title,
        infotext: event.currentTarget.dataset.infotext,
        weight: event.currentTarget.dataset.weight,
        composition: event.currentTarget.dataset.composition,
        weave: event.currentTarget.dataset.weave,
        yarn: event.currentTarget.dataset.yarn,
        refnr: event.currentTarget.dataset.refnr,
        price: Number(event.currentTarget.dataset.price).toFixed(2)
      }
      this.show = true
    },
    addMobileSample: function (event) {
      /*global localStorage: false */
      var exists = false
      var message = ''
      var free = ''
      var keys = ['muster1', 'muster2', 'muster3', 'muster4']
      var i = 0
      var key
      while (keys[i]) {
        key = keys[i]
        if (localStorage.getItem(key)) {
          if (event.currentTarget.dataset.refnr === JSON.parse(localStorage.getItem(key))) {
            exists = key
            break
          }
        } else {
          if (!free) free = key
        }
        i++
      }
      if (!exists && free) {
        localStorage.setItem(free, JSON.stringify(event.currentTarget.dataset.refnr))
        this.$dispatch('setSwatch', {key: free, value: event.currentTarget.dataset.refnr})
        this.$dispatch('setMsg', {success: this.translations['Added to swatch box.']})
      } else {
        if (exists) {
          localStorage.removeItem(key)
          this.$dispatch('setSwatch', {key: key, value: ''})
          message = this.translations['Removed from swatch box.']
          this.$dispatch('setMsg', {success: message})
        } else {
          message = this.translations['You have already four fabrics in swatch box.']
          this.$dispatch('setMsg', {error: message})
        }
      }
    }
  },
  created: function () {
    this.setCurrentData(this.personal[this.box.component])
  },
  ready: function () {
    this.$dispatch('runDesignJQuery')
  }
}

</script>



// WEBPACK FOOTER //
// ContrastCollarOutside.vue?23854064